// extracted by mini-css-extract-plugin
module.exports = {"featureMenu":"_1tAtv_8c","menuContainer":"_1LaPAJwN","menuCaption":"xV8nag_m","actionButton":"_2iXZdzvQ"};